import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Does flintly change how my agent behaves?",
    a: "No. Flintly sits between your agent and the model as a local proxy. Prompts, tools, and habits stay identical — the context window just arrives smaller, and the agent can recall the original content through MCP whenever it needs it.",
  },
  {
    q: "Which agents are supported?",
    a: "Claude Code, Cursor, Aider, Gemini CLI, Codex, and OpenCode at launch, with a generic OpenAI-compatible proxy for anything else. TypeScript and Python (LangChain) middleware are included for app-level integration.",
  },
  {
    q: "Is my code sent to flintly servers?",
    a: "Never for the local tools. Compression runs entirely on localhost. Flintly Cloud only receives anonymized token counts and run metadata if your team opts in to the analytics plane.",
  },
  {
    q: "What does it cost?",
    a: "The local proxy and agent skill are free for individuals. Flintly Cloud for teams is usage-based with a free trial — exact tiers are finalized with the early access cohort.",
  },
  {
    q: "How do I verify the savings?",
    a: "Every run writes a token ledger entry: input before, input after, recalled bytes, and model used. The dashboard shows savings per session, per repo, and per seat — no black box.",
  },
];

export const Faq = () => {
  return (
    <section
      data-testid="faq-section"
      className="max-w-3xl mx-auto px-6 py-24 border-b border-seam"
    >
      <div className="mb-10 text-center">
        <span className="text-xs font-semibold uppercase tracking-widest text-ember">
          Questions
        </span>
        <h2 className="font-serif text-3xl sm:text-4xl text-white mt-1">
          Asked around the campfire
        </h2>
      </div>

      <Accordion type="single" collapsible className="w-full">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`item-${i}`}
            className="border-seam"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger
              className="text-sm font-semibold text-white hover:text-ember hover:no-underline text-left"
              data-testid={`faq-trigger-${i}`}
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent
              className="text-xs text-smoke leading-relaxed"
              data-testid={`faq-content-${i}`}
            >
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
